import { ExtractsRepository } from 'domain/repositories/extract-repository';
import { ExtractHttpRepository } from '../../../../data/repositories/http/extract-http-repository';
import { makeCryptoHttpDatasource } from '../../../../main/factories/datasources/http/http-datasource-factory';
import { makeCryptoUrlDatasource } from '../../../../main/factories/datasources/url/url-datasource-factory';

export const makeExtractsHttpRepository = (): ExtractsRepository => {
  return new ExtractHttpRepository(makeCryptoHttpDatasource(), makeCryptoUrlDatasource());
};
